import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Button, Container, Form } from "reactstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { TextField } from "@mui/material";
import { textfield_style } from "../../../../../variables/constants";

function AdminManageGST(props) {
  const { open, onClose, fieldData, setFieldData, handleSubmit, loading } =
    props;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        // initialFocus={cancelButtonRef}
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <Container
          className="fixed inset-0 z-10 overflow-y-auto mt-10"
          // onClick={onClose}
        >
          <div className="flex items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <Container className="flex justify-between items-center">
                  <p className="ml-5 text-lg font-semibold">
                    {fieldData.isEdit ? "Update" : "Add"} GST Slab
                  </p>
                  <Dialog.Title
                    as="button"
                    onClick={onClose}
                    className="text-lg font-medium leading-6 text-gray-900 text-right p-5 outline-none"
                  >
                    <AiOutlineCloseCircle />
                  </Dialog.Title>
                </Container>

                <Form onSubmit={handleSubmit} className="mx-5 mb-6 -mt-3">
                  <TextField
                    fullWidth
                    label="Enter Tax Name"
                    id="fullWidth"
                    sx={textfield_style}
                    value={fieldData.tax_name ?? ""}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, tax_name: e.target.value })
                    }
                    required
                  />
                  <TextField
                    fullWidth
                    type="number"
                    label="Enter CGST"
                    id="fullWidth"
                    sx={textfield_style}
                    // InputProps={{ inputProps: { max: 100 } }}
                    value={fieldData.cgst ?? ""}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, cgst: e.target.value })
                    }
                    required
                  />
                  <TextField
                    fullWidth
                    type="number"
                    label="Enter SGST"
                    id="fullWidth"
                    sx={textfield_style}
                    // InputProps={{ inputProps: { max: 100 } }}
                    value={fieldData.sgst ?? ""}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, sgst: e.target.value })
                    }
                    required
                  />

                  <Container className="flex justify-end items-center my-5">
                    {!loading.btn ? (
                      <Button
                        type="submit"
                        className="px-8 py-2 bg-slate-800 text-white font-semibold rounded-lg active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out disabled:cursor-not-allowed disabled:bg-slate-500"
                        //   disabled={
                        //     props.data.name.length < 1 ||
                        //     props.selectedImages.length !== 1
                        //       ? true
                        //       : false
                        //   }
                      >
                        {fieldData.isEdit ? "Update" : "Save"}
                      </Button>
                    ) : (
                      <Button className="bg-[#8881a7] py-2 px-8 text-white rounded-lg cursor-not-allowed">
                        Loading...
                      </Button>
                    )}
                  </Container>
                </Form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Container>
      </Dialog>
    </Transition.Root>
  );
}

export default AdminManageGST;
